module.exports = __webpack_public_path__ + "static/img/暴雨转大暴雨.c29d066f.svg";